import { makeAutoObservable } from 'mobx';
import { z } from 'zod';
import type { StringDto } from '../../../../../../store/utils/Dto';
import extractValue, {
  type EventOrValue,
} from '../../../../../../store/utils/extractValue';
import Validator from '../../../../../../store/utils/Validator';
import { errorHandler } from '../../../../../../utils/errors';

export default class ProductMerging {
  static readonly Schema = z.object({
    isMergeable: z.boolean(),
  });

  isMergeable = false;

  private readonly validator = new Validator(this, ProductMerging.Schema);

  constructor(
    dto: ProductMergingDto | undefined,
    private readonly onSave: (hiseLink: ProductMerging) => Promise<void>,
  ) {
    makeAutoObservable(this, {}, { autoBind: true });

    this.isMergeable = dto || false;
  }

  get errors(): StringDto<ProductMergingDto> {
    return this.validator.errorsForEnabledFields;
  }

  handleChange(e: EventOrValue) {
    const { name, value } = extractValue(e);
    Object.assign(this, { [name]: value });
    this.validator.validate();
    this.save();
  }

  handleBlur(e: EventOrValue<keyof ProductMerging>) {
    const { name } = extractValue(e);
    this.validator.enableFieldValidation(name);
  }

  save() {
    this.onSave(this).catch(errorHandler('Cannot save product merging'));
  }

  toJSON(): ProductMergingDto | undefined {
    return this.isMergeable || undefined;
  }
}

export type ProductMergingDto = boolean;
